import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FirstPageService } from '../_services/first-page.service';

export const checkInfoGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _service = inject(FirstPageService);

  const _path = route.routeConfig?.path;
  const test = localStorage.getItem('first');

  if (test) {
    if (_path == 'info') {
      _router.navigate(['/']);
      return false;
    } else {
      return true;
    }
  } else {
    if (_path != 'info') {
      if (_service.test) { return true }
      else {
        _router.navigate(['/', 'info']);
        return false;
      }
    } else {
      return true;
    }
  }
};
